import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.rhythm');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

type RhythmMenuId = 'taiko' | 'iidx' | 'popn' | 'sdvx';

const SIDEBAR_STORAGE_KEY = 'taigo_rhythm_sidebar_state_v2';
const DEFAULT_SIDEBAR_OPEN = false;
const MENU_ORDER_STORAGE_PREFIX = 'taigo_rhythm_menu_order_v1';
const MENU_ACTIVE_OWNER_STORAGE_KEY = 'taigo_rhythm_menu_active_owner_v1';
const DEFAULT_MENU_ORDER: RhythmMenuId[] = ['taiko', 'iidx', 'popn', 'sdvx'];
const PRIVATE_ACCOUNT_ID = 'nnnewnxxapseyldhonxpghbqkjykgduh';

@Component({
    selector: 'wiz-layout-rhythm',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.rhythm/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.rhythm-layout {
  min-height: 100vh;
  background: transparent;
}

.rhythm-content {
  min-height: 100vh;
  transition: padding-left 0.2s ease;
}

.rhythm-sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 60;
  width: 184px;
  border-right: 1px solid #27272a;
  background: rgba(24, 24, 27, 0.96);
  color: #f4f4f5;
  transition: width 0.2s ease, transform 0.2s ease;
}

.rhythm-sidebar-inner {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  padding: 8px 7px;
}

.rhythm-sidebar-head {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #27272a;
  padding-bottom: 6px;
}

.rhythm-sidebar-title {
  color: #a1a1aa;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
}

.rhythm-toggle,
.rhythm-mobile-open {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #3f3f46;
  border-radius: 8px;
  background: #18181b;
  color: #d4d4d8;
  cursor: pointer;
  padding: 0;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.rhythm-toggle:hover,
.rhythm-mobile-open:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.rhythm-toggle svg,
.rhythm-mobile-open svg {
  width: 17px;
  height: 17px;
}

.rhythm-menu {
  display: grid;
  gap: 4px;
  margin-top: 10px;
}

.rhythm-account {
  margin-top: auto;
  border-top: 1px solid #27272a;
  padding-top: 8px;
}

.rhythm-nav-item {
  display: flex;
  min-height: 36px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
}

.rhythm-nav-item.is-dragging {
  opacity: 0.55;
}

.rhythm-drag-handle {
  display: inline-flex;
  width: 22px;
  height: 36px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #71717a;
  cursor: grab;
  touch-action: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.rhythm-nav-item:hover .rhythm-drag-handle {
  border-color: #3f3f46;
  background: #18181b;
  color: #a1a1aa;
}

.rhythm-drag-handle:active {
  cursor: grabbing;
}

.rhythm-drag-handle svg {
  width: 14px;
  height: 14px;
}

.rhythm-nav-link {
  display: flex;
  min-height: 36px;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #a1a1aa;
  padding: 0 8px;
  text-decoration: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.rhythm-nav-link:hover {
  border-color: #3f3f46;
  background: #18181b;
  color: #f4f4f5;
}

.rhythm-nav-link.is-active {
  border-color: #3f3f46;
  background: #27272a;
  box-shadow: inset 3px 0 0 #22d3ee;
  color: #67e8f9;
}

.rhythm-link-icon {
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
}

.rhythm-link-icon svg {
  width: 20px;
  height: 20px;
}

.rhythm-link-label {
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
}

.rhythm-sidebar.is-closed .rhythm-sidebar-head,
.rhythm-sidebar.is-closed .rhythm-nav-item {
  justify-content: center;
}

.rhythm-sidebar.is-closed .rhythm-nav-link {
  justify-content: center;
  flex: 0 0 36px;
  padding: 0;
}

.rhythm-scrim {
  position: fixed;
  inset: 0;
  z-index: 55;
  background: rgba(0, 0, 0, 0.5);
}

.rhythm-mobile-open {
  position: fixed;
  bottom: 18px;
  left: 14px;
  z-index: 54;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);
}

@media (min-width: 768px) {
  .rhythm-layout.is-open .rhythm-content {
    padding-left: 184px;
  }
  .rhythm-layout.is-closed .rhythm-content {
    padding-left: 48px;
  }
  .rhythm-sidebar.is-closed {
    width: 48px;
  }
}
@media (max-width: 767px) {
  .rhythm-layout {
    background: transparent;
  }
  .rhythm-content {
    padding-left: 0;
  }
  .rhythm-sidebar {
    width: min(78vw, 220px);
    transform: translateX(-100%);
  }
  .rhythm-sidebar.is-open {
    transform: translateX(0);
  }
  .rhythm-sidebar.is-closed {
    transform: translateX(-100%);
  }
}
:host-context([data-taigo-theme=light]) .rhythm-sidebar {
  border-right-color: #d4d4d8;
  background: rgba(255, 255, 255, 0.96);
  color: #18181b;
}

:host-context([data-taigo-theme=light]) .rhythm-sidebar-head {
  border-bottom-color: #e4e4e7;
}

:host-context([data-taigo-theme=light]) .rhythm-account {
  border-top-color: #e4e4e7;
}

:host-context([data-taigo-theme=light]) .rhythm-toggle,
:host-context([data-taigo-theme=light]) .rhythm-mobile-open {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
}

:host-context([data-taigo-theme=light]) .rhythm-nav-link {
  color: #52525b;
}

:host-context([data-taigo-theme=light]) .rhythm-nav-link:hover {
  border-color: #d4d4d8;
  background: #f4f4f5;
  color: #18181b;
}

:host-context([data-taigo-theme=light]) .rhythm-nav-item:hover .rhythm-drag-handle {
  border-color: #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
}

:host-context([data-taigo-theme=light]) .rhythm-nav-link.is-active {
  border-color: #d4d4d8;
  background: #ecfeff;
  box-shadow: inset 3px 0 0 #0891b2;
  color: #0e7490;
}`],
})
export class LayoutRhythmComponent implements OnInit, OnDestroy {
    public sidebarOpen: boolean = DEFAULT_SIDEBAR_OPEN;
    public isMobile: boolean = false;
    public currentPath: string = '';
    public menuOrder: RhythmMenuId[] = [...DEFAULT_MENU_ORDER];
    public draggingMenuId: RhythmMenuId | null = null;
    private routerSub?: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.refreshAuthSession();
        this.menuOrder = this.loadMenuOrder();
        this.rememberActivePreferenceOwner();
        this.currentPath = this.getPathname();
        this.syncViewport(true);
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.currentPath = event.urlAfterRedirects.split('?')[0];
                if (this.isMobile) this.sidebarOpen = false;
                await this.service.render();
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    @HostListener('window:resize')
    public onResize() {
        this.syncViewport(false);
    }

    public async toggleSidebar(event?: Event) {
        if (event) event.stopPropagation();
        this.sidebarOpen = !this.sidebarOpen;
        this.saveSidebarState();
        await this.service.render();
    }

    public async openSidebar(event?: Event) {
        if (event) event.stopPropagation();
        this.sidebarOpen = true;
        this.saveSidebarState();
        await this.service.render();
    }

    public async closeSidebar(event?: Event) {
        if (event) event.stopPropagation();
        this.sidebarOpen = false;
        this.saveSidebarState();
        await this.service.render();
    }

    public async handleNavClick() {
        if (!this.isMobile) return;
        this.sidebarOpen = false;
        await this.service.render();
    }

    public isActive(section: RhythmMenuId): boolean {
        const path = this.currentPath || this.getPathname();
        if (section === 'taiko') return path === '/taiko' || path.startsWith('/taiko/');
        if (section === 'iidx') return path === '/iidx' || path.startsWith('/iidx/');
        if (section === 'popn') return path === '/popn' || path.startsWith('/popn/');
        return path === '/sdvx' || path.startsWith('/sdvx/');
    }

    public isProfileActive(): boolean {
        const path = this.currentPath || this.getPathname();
        return path === '/mypage' || path.startsWith('/mypage/');
    }

    public canViewPrivateGames(): boolean {
        const session = (this.service?.auth?.session || {}) as any;
        return String(session.id || '') === PRIVATE_ACCOUNT_ID;
    }

    public getMenuOrder(id: RhythmMenuId): number {
        const index = this.menuOrder.indexOf(id);
        return index >= 0 ? index : DEFAULT_MENU_ORDER.indexOf(id);
    }

    public startMenuDrag(id: RhythmMenuId, event: DragEvent) {
        if (!this.sidebarOpen) {
            event.preventDefault();
            return;
        }

        this.draggingMenuId = id;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', id);
        }
    }

    public allowMenuDrop(event: DragEvent) {
        if (!this.draggingMenuId) return;
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    }

    public async dropMenuItem(targetId: RhythmMenuId, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        const sourceId = this.draggingMenuId;
        this.draggingMenuId = null;
        if (!sourceId || sourceId === targetId) return;

        const from = this.menuOrder.indexOf(sourceId);
        const to = this.menuOrder.indexOf(targetId);
        if (from < 0 || to < 0) return;

        const nextOrder = [...this.menuOrder];
        const [moved] = nextOrder.splice(from, 1);
        nextOrder.splice(to, 0, moved);
        this.menuOrder = this.normalizeMenuOrder(nextOrder);
        await this.refreshAuthSession();
        this.saveMenuOrder();
        await this.service.render();
    }

    public endMenuDrag() {
        this.draggingMenuId = null;
    }

    public getToggleLabel(): string {
        return this.sidebarOpen ? '사이드바 닫기' : '사이드바 열기';
    }

    public isGlobalLoading(): boolean {
        return !!(this.service.status as any).loading;
    }

    private syncViewport(initial: boolean) {
        const nextIsMobile = this.getIsMobile();
        const changed = nextIsMobile !== this.isMobile;
        this.isMobile = nextIsMobile;

        if (initial) {
            this.sidebarOpen = this.isMobile ? false : this.loadSidebarState();
            return;
        }

        if (!changed) return;
        this.sidebarOpen = this.isMobile ? false : this.loadSidebarState();
        this.service.render();
    }

    private getIsMobile(): boolean {
        try {
            return window.innerWidth < 768;
        } catch {
            return false;
        }
    }

    private getPathname(): string {
        try {
            return location.pathname || '/';
        } catch {
            return '/';
        }
    }

    private loadSidebarState(): boolean {
        try {
            const saved = localStorage.getItem(SIDEBAR_STORAGE_KEY);
            if (saved === 'open') return true;
            if (saved === 'closed') return false;
            return DEFAULT_SIDEBAR_OPEN;
        } catch {
            return DEFAULT_SIDEBAR_OPEN;
        }
    }

    private saveSidebarState() {
        if (this.isMobile) return;
        try {
            localStorage.setItem(SIDEBAR_STORAGE_KEY, this.sidebarOpen ? 'open' : 'closed');
        } catch { }
    }

    private loadMenuOrder(): RhythmMenuId[] {
        try {
            const saved = localStorage.getItem(this.getMenuStorageKey());
            if (!saved) return [...DEFAULT_MENU_ORDER];
            return this.normalizeMenuOrder(JSON.parse(saved));
        } catch {
            return [...DEFAULT_MENU_ORDER];
        }
    }

    private saveMenuOrder() {
        try {
            localStorage.setItem(this.getMenuStorageKey(), JSON.stringify(this.menuOrder));
            this.rememberActivePreferenceOwner();
        } catch { }
    }

    private getMenuStorageKey(): string {
        return `${MENU_ORDER_STORAGE_PREFIX}:${this.getPreferenceOwnerKey()}`;
    }

    private getPreferenceOwnerKey(): string {
        const session = (this.service?.auth?.session || {}) as any;
        if (session.id) return `user:${String(session.id)}`;
        if (session.email) return `email:${String(session.email)}`;
        return 'guest';
    }

    private rememberActivePreferenceOwner() {
        try {
            localStorage.setItem(MENU_ACTIVE_OWNER_STORAGE_KEY, this.getPreferenceOwnerKey());
        } catch { }
    }

    private async refreshAuthSession() {
        try {
            await this.service.auth.init();
        } catch { }
    }

    private normalizeMenuOrder(value: any): RhythmMenuId[] {
        const order: RhythmMenuId[] = [];
        if (Array.isArray(value)) {
            for (const item of value) {
                if (this.isMenuId(item) && !order.includes(item)) order.push(item);
            }
        }

        for (const item of DEFAULT_MENU_ORDER) {
            if (!order.includes(item)) order.push(item);
        }
        return order;
    }

    private isMenuId(value: any): value is RhythmMenuId {
        return value === 'taiko' || value === 'iidx' || value === 'popn' || value === 'sdvx';
    }
}

export default LayoutRhythmComponent;